import React, { memo, useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { useRequestHook } from "utils/hooks/hooks";
import { DOWNLOAD_DOCTYPES_WRAPPER } from "utils/constants.json";

const DownloadDoctypes = ({ getTypesData, serviceName }) => {
  const [container, setContainer] = useState(() => null);
  const { handleRequest } = useRequestHook();

  const exportToExcel = () => {
    handleRequest(
      "post",
      "/documents-types/load-allowed-types",
      {
        ...getTypesData,
        sendExcelBuffer: true,
        serviceName,
      },
      (response, msg, data) => {
        const blob = new Blob([data]);

        const filename = `Typen für ${serviceName}.xlsx`;

        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
          const a = document.createElement("a");
          document.body.appendChild(a);
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = filename;
          a.click();
          setTimeout(() => {
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
          }, 0);
        }
      },
      "blob"
    );
  };

  useEffect(() => {
    setContainer(document.getElementById(DOWNLOAD_DOCTYPES_WRAPPER));
  }, []);

  if (!container) return null;
  return createPortal(
    <i
      title="Dokumenttypen herunterladen"
      className="fa fa-solid fa-file ml-3 pointer position-relative"
      onClick={exportToExcel}
    >
      <span
        style={{
          position: "absolute",
          bottom: "-2px",
          left: "3px",
          fontFamily: "sans-serif",
          fontSize: "5pt",
          fontWeight: "2000",
          color: "#009688",
          backgroundColor: "white",
          borderRadius: "0.1rem",
          padding: "0.1rem",
        }}
      >
        XLSX
      </span>
    </i>,
    container
  );
};

export default memo(DownloadDoctypes);
